export default __webpack_public_path__ + "static/aprons-010e87d2b3469f66c47a6b715d5a1f6d.webp";